import React from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';
import 'react-select/dist/react-select.css';
import { MdDelete } from 'react-icons/lib/md';

import { DateField } from './schedule_utils'; 
import { getDateValue } from '../../utils/date';

class BlueBookForm extends React.Component {
//     static PropTypes = {
//     blueBook: PropTypes.object.isRequired,
//     contracts: PropTypes.array.isRequired, 
//     handleChange: PropTypes.func.isRequired,
//     handleDateChange: PropTypes.func.isRequired,
//     handleCPMChange: PropTypes.func.isRequired,
//     handleCPMChangeOut: PropTypes.func.isRequired,
//     onSubmit: PropTypes.func.isRequired,
//     addChildRow: PropTypes.func.isRequired,
//     handleRegChange: PropTypes.func.isRequired,
//     handleChangeChildRow: PropTypes.func.isRequired,
//     deleteChildRow: PropTypes.func.isRequired
//   }
  
  getRegistrationOptions() {
    return this.props.contracts.map(contract => {
      return {
        label: contract.regNumber,
        value: contract.regNumber
      }
    });
  }

  getCPMoptions() {
        const values = ['AM', 'PM'];
        return values.map(value => {
          return { label: value, value }
        });
  }

    render() {
        const {blueBook} = this.props;
        return (
            <form className="modal-form blue-book-form" onSubmit={this.props.onSubmit}>

            <div className="border-grey">
                <div className="row">
                    <div className="col l2 m4 s12">
                        <div className="control required">
                            <label>Date of Visit</label>
                            {blueBook.disabled ? getDateValue(blueBook.dateVisit)

                            :
                            <DateField name="dateVisit" 
                                value={blueBook.dateVisit} limits={{}}
                                onChange={this.props.handleDateChange('dateVisit')} 
                                
                            />}
                            <br />
                            <span className="error">{this.props.errors.dateVisit}</span>
                        </div>
                    </div>
                    <div className="col l2 m4 s12">
                        <div className="control required">
                            <label>Day of Week</label>
                            <input type="text" name="dayOfWeek" readOnly
                                value={blueBook.dayOfWeek}
                                onChange={this.props.handleChange('dayOfWeek')} disabled={blueBook.disabled}
                            />
                        </div>
                    </div>
                    <div className="col l2 m4 s12">
                        <div className="control">
                            <label>Registration</label>
                            <Select name="contractRegNo"
                                value={blueBook.contractRegNo}
                                options={this.getRegistrationOptions()}
                                onChange={this.props.handleRegChange} disabled={blueBook.disabled}
                            />
                        </div>
                    </div>
                    <div className="col l2 m4 s12">
                        <div className="control">
                            <label>CCD #</label>
                            <input type="number" name="ccd" maxLength="6" min="0" max="99999"
                                value={blueBook.ccd}
                                onChange={this.props.handleChange('ccd')} disabled={blueBook.disabled}
                            />
                        </div>
                    </div>
                    <div className="col l2 m4 s12">
                        <div className="control">
                            <label>Of</label>
                            <input type="number" name="totalCCD" maxLength="6" min="0" max="99999"
                                value={blueBook.totalCCD}
                                onChange={this.props.handleChange('totalCCD')} disabled={blueBook.disabled}
                            />
                        </div>
                    </div>
                    <div className="col l2 m4 s12">
                        <div className="control required">
                            <label>Weather</label>
                            <input type="text" name="weather" maxLength="10"
                                value={blueBook.weather}
                                onChange={this.props.handleChange('weather')} disabled={blueBook.disabled}
                            />
                            <br />
                            <span className="error">{this.props.errors['weather']}</span>
                        </div>
                    </div>
                </div>


                <div className="row">
                    <div className="col l2 m4 s12">
                        <div className="control required">
                            <label>Temp: AM &deg;F</label>
                            <input type="number" name="tempAM" maxLength="3" min="0" max="200"
                                value={blueBook.tempAM}
                                onChange={this.props.handleChange('tempAM')} disabled={blueBook.disabled}
                            />
                            <br />
                            <span className="error">{this.props.errors['tempAM']}</span>
                        </div>
                    </div>

                    <div className="col l2 m4 s12">
                        <div className="control required">
                            <label>Temp: PM &deg;F</label>
                            <input type="number" name="tempPM"  maxLength="3" min="0" max="200"
                                value={blueBook.tempPM}
                                onChange={this.props.handleChange('tempPM')} disabled={blueBook.disabled}
                            />
                            <br />
                            <span className="error">{this.props.errors['tempPM']}</span>
                        </div>
                    </div>

                    <div className="col l8 m4 s12">
                        <div className="control required">
                            <label className="margin-top--12">Site Condition</label>
                                <textarea name="siteCondition" rows="2" value={blueBook.siteCondition} id="textarea-custom-bordered" maxLength="300" className="margin-bottom--6"
                                    onChange={this.props.handleChange('siteCondition')} disabled={blueBook.disabled}
                                />
                            <br />
                            <span className="error">{this.props.errors['siteCondition']}</span>
                        </div>
                    </div>

                </div>
            </div>

                <div className="row">
                    <div className="col l2 offset-l10 m2 offset-m10 s6 offset-s6 padding-right-0 margin-top-075 margin-bottom-075">
                        <button className="btn-save float-right" onClick={this.props.addChildRow} disabled={blueBook.disabled}>Add</button>
                    </div>
                </div>

                <div className="blue-book">
                    <div className="table-wrap">
                        <table>
                            <thead>
                                <tr>
                                    <th>Prime Trade</th>
                                    <th>Sub Trade</th>
                                    <th>Actual # of Workers *</th>
                                    <th>Hours *</th>
                                    <th>Special Equipment</th>
                                    <th>Location and Description of Work in progress *</th>
                                    <th>Actions</th>
                                </tr>
                            </thead>
                             <tbody>
                                {
                                    this.props.blueBook.blueBookTrades.map((childRow, index) =>
                                    
                                        <tr key={index}>
                                            <td> <input type="text" name="primeTrade" maxLength="100"
                                                value={childRow.primeTrade}
                                                onChange={this.props.handleChangeChildRow('primeTrade', index)} disabled={blueBook.disabled}
                                            />
                                            <br/> 
                                            <div className="error height-20">{this.props.errors.blueBookTrades[index]['primeTrade']}</div>
                                            
                                            </td>
                                            <td><input type="text" name="subTrade" maxLength="100"
                                                value={childRow.subTrade}
                                                onChange={this.props.handleChangeChildRow('subTrade', index)} disabled={blueBook.disabled}
                                            />
                                            <br/>
                                            <div className="error height-20">{this.props.errors.blueBookTrades[index]['subTrade']}</div>
                                            </td>
                                            <td><input type="number" name="noWorkers" maxLength="4" min="0" max="9999"
                                                value={childRow.noWorkers}
                                                onChange={this.props.handleChangeChildRow('noWorkers', index)} disabled={blueBook.disabled}
                                            />
                                             <br/>
                                            <div className="error height-20">{this.props.errors.blueBookTrades[index]['noWorkers']}</div>
                                            </td>
                                 
                                    <td>
                                        <input type="number" name="hours" maxLength="4" min="0" max="200"
                                                value={childRow.hours}
                                                onChange={this.props.handleChangeChildRow('hours', index)} disabled={blueBook.disabled}
                                            />
                                            <br/>
                                            <div className="error height-20">{this.props.errors.blueBookTrades[index]['hours']}</div>
                                        </td>
                                            <td>
                                                <textarea name="specialEquipment" rows="2" value={childRow.specialEquipment} id="textarea-custom-bordered" maxLength="100" className="width-100-custom"
                                                    onChange={this.props.handleChangeChildRow('specialEquipment', index)} disabled={blueBook.disabled}
                                                />
                                          
                                                <br />
                                                <div className="error height-20">{this.props.errors.blueBookTrades[index]['specialEquipment']}</div>
                                            </td>
                                            <td>
                                                <textarea name="locDescWorkInProgress" rows="2" value={childRow.locDescWorkInProgress} id="textarea-custom-bordered" maxLength="100" className="width-100-custom"
                                                    onChange={this.props.handleChangeChildRow('locDescWorkInProgress', index)} disabled={blueBook.disabled}
                                                />
                                                <br />
                                                <div className="error height-20">{this.props.errors.blueBookTrades[index]['locDescWorkInProgress']}</div>
                                            </td>
                                    <td>
                                        <button onClick={this.props.deleteChildRow(index)}>
                                        <span><MdDelete size={22} color='#8492a6'/></span>  
                                        </button>
                                        </td>
                                        </tr>
                                    )}
                            </tbody> 
                        </table>
                    </div>
                </div>

                <div className="row">
                    <div className="control">
                        <label>General remarks: Reasons for delay, special instructions, tests, shut downs, notable incidents, materials delivered to site</label>
                        <textarea name="comments" cols="3" rows="5"  value={blueBook.comments} id="textarea-custom-bordered" maxLength="2000"
                            onChange={this.props.handleChange('comments') } disabled={blueBook.disabled}
                        />
                    </div>
                </div>
            
             <div className="row">

                    <div className="col l2 m3 s12 padding-botom-sm-show">
                        <div className="md-checkbox">
                            <input type="checkbox" name="notAtSite" id="notAtSite"
                                checked={blueBook.notAtSite}
                                onChange={this.props.handleCheckBoxChange('notAtSite')} disabled={blueBook.disabled}
                            />
                            <label htmlFor="notAtSite">Not at site</label>
                        </div>
                    </div>                

               { blueBook.notAtSite ? null:

                        <div className="col l4 m4 s12">
                            <div className="control required">
                                <label>CPM Time in (<b>XX:XX AM/PM</b>)</label>
                                <div className="col l3 m4 s4 padding-left-0">
                                    <input type="text" name="timeInHours" maxLength="5"
                                        placeholder="08:00"
                                        value={blueBook.timeInHours}
                                        onChange={this.props.handleChangeCPMtime('timeInHours')} disabled={blueBook.disabled}
                                    />
                                </div>
                                <div className="col l5 m8 s8">
                                <Select  name="timeIn"
                                    value={blueBook.timeIn}
                                    options={this.getCPMoptions()}
                                  onChange={this.props.handleCPMChange}
                                  placeholder="AM/PM"
                                  className="custom-margin-bottom"
                                />
                                </div>
                                <div className="error padding-left-0 col l12">{this.props.errors['cpmTimeIn']}</div>
                            </div>
                        </div> 
                 }
                 { blueBook.notAtSite ? null:
                <div className="col l4 m5 s12">
                    <div className="control required">
                        <label>CPM Time out (XX:XX AM/PM)</label>
                        <div className="col l3 m4 s4 padding-left-0">
                        <input type="text" name="timeOutHours" maxLength="5"
                            value={blueBook.timeOutHours}
                            placeholder="11:00"
                            onChange={this.props.handleChangeCPMtimeOut('timeOutHours')} disabled={blueBook.disabled}
                        />
                        </div>
                        <div className="col l5 m8 s8">
                                <Select  name="timeOut"
                                    value={blueBook.timeOut}
                                    options={this.getCPMoptions()}
                                  onChange={this.props.handleCPMChangeOut}
                                  placeholder="AM/PM"
                                  className="custom-margin-bottom"
                                />
                                </div>
                            <div className="error padding-left-0 col l12">{this.props.errors['cpmTimeOut']}</div>
                    </div>                                  
                </div>
                 }
               
            </div>

                <div className="actions">
                    <button className="btn-update btn-update-custom" disabled={blueBook.disabled}>SAVE</button>
                    
                    {this.props.errMsg && <span className="color-orange">Please correct errors marked in red</span>}
                    </div>
            </form>
        );
    }
}

BlueBookForm.propTypes = {
    blueBook: PropTypes.object.isRequired,
    contracts: PropTypes.array.isRequired, 
    handleChange: PropTypes.func.isRequired,
    handleDateChange: PropTypes.func.isRequired,
    handleCPMChange: PropTypes.func.isRequired,
    handleCPMChangeOut: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired,
    addChildRow: PropTypes.func.isRequired,
    handleRegChange: PropTypes.func.isRequired,
    handleChangeChildRow: PropTypes.func.isRequired,
    deleteChildRow: PropTypes.func.isRequired,
    project: PropTypes.object.isRequired,
    onChangeWatch: PropTypes.func.isRequired
};

export default BlueBookForm;